/**
 * Shared sort-direction helpers. The `SortDirection` type itself is part of the
 * GraphQL contract (`graphql/types.ts`); this module adds the small UI helpers
 * so screens don't re-implement the ASC/DESC toggle inline.
 */
import type { SortDirection } from "../graphql/types";

export const OPPOSITE_SORT_DIRECTION: Record<SortDirection, SortDirection> = {
  ASC: "DESC",
  DESC: "ASC",
};

/** Flip a sort direction (ASC ↔ DESC). */
export function toggleSortDirection(dir: SortDirection): SortDirection {
  return OPPOSITE_SORT_DIRECTION[dir];
}
